import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/index.css';
// Diseño de los campos de toda la tienda (después de Bootstrap para que gane).
import './styles/forms.css';
// Diseño de los botones de acción de toda la tienda.
import './styles/buttons.css';

// import {
//   BrowserRouter as Router,
//   Route,
//   Switch,
//   Redirect,
// } from 'react-router-dom';
// 🟢 Importa la configuración global
import setupAxios from './setupAxios';

// 🟢 Inicializa Axios para toda la app
setupAxios();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
